export const STORE_NAME = "Pomelo Bebés"
export const WHATSAPP_NUMBER = "+5491122907227"